import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS } from "../apiEndpoints";

export const selectPlanApi = (userId, planTitle) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.SELECT_PLAN}`,
    { userId, planTitle },
    { headers: { "Content-Type": "application/json", Connection: "close" } },
  );

export const verifyPaymentApi = (psid) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.VERIFY_PAYMENT}`,
    { psid },
    { headers: { "Content-Type": "application/json" } },
  );

export const checkPendingTransaction = (userId, planId) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.PENDING_TRANSACTION}`,
    { userId, planId },
    { headers: { "Content-Type": "application/json" } },
  );
